var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15447_2002)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2422 -0.0390625C19.388 -0.0390625 20.5338 -0.0390625 21.6797 -0.0390625C29.513 0.940688 35.0989 5.00319 38.4375 12.1484C39.2419 14.1159 39.7497 16.1472 39.9609 18.2422C39.9609 19.388 39.9609 20.5338 39.9609 21.6797C38.9812 29.513 34.9187 35.0989 27.7734 38.4375C25.8059 39.2419 23.7747 39.7497 21.6797 39.9609C20.5338 39.9609 19.388 39.9609 18.2422 39.9609C15.0054 39.645 12.0105 38.6163 9.25781 36.875C9.13797 36.8029 9.00773 36.7638 8.86719 36.7578C6.33637 37.5493 3.81034 38.3566 1.28906 39.1797C2.05037 36.6999 2.85766 34.213 3.71094 31.7188C1.58905 28.6996 0.339054 25.3533 -0.0390625 21.6797C-0.0390625 20.5338 -0.0390625 19.388 -0.0390625 18.2422C0.940688 10.4089 5.00319 4.82297 12.1484 1.48438C14.1159 0.679995 16.1472 0.172182 18.2422 -0.0390625ZM11.7578 9.17969C12.3313 9.16672 12.9042 9.17969 13.4766 9.21875C13.6745 9.25906 13.8438 9.35023 13.9844 9.49219C14.8511 11.3163 15.6193 13.1783 16.2891 15.0781C16.1895 15.5248 15.9942 15.9284 15.7031 16.2891C15.3204 16.6648 14.9559 17.0554 14.6094 17.4609C14.3605 17.7577 14.2823 18.0963 14.375 18.4766C16.2751 21.8868 19.0485 24.2957 22.6953 25.7031C23.0525 25.7724 23.391 25.7203 23.7109 25.5469C24.3045 24.9014 24.8384 24.2113 25.3125 23.4766C25.572 23.0991 25.9236 22.8647 26.3672 22.7734C28.2795 23.5017 30.1154 24.3871 31.875 25.4297C32.1812 27.9555 31.1525 29.6873 28.7891 30.625C27.708 31.092 26.5882 31.2222 25.4297 31.0156C21.0209 30.1205 17.2579 28.0763 14.1406 24.8828C12.6358 23.2776 11.2816 21.5588 10.0781 19.7266C9.24023 18.4373 8.69336 17.0311 8.4375 15.5078C8.20031 13.2501 8.89039 11.336 10.5078 9.76562C10.9017 9.50336 11.3184 9.30805 11.7578 9.17969Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15447_2002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappNew);
export default __webpack_public_path__ + "static/media/whatsappNew.c73b9228a2a1442be01e1df8460d8e42.svg";
export { ForwardRef as ReactComponent };